module.exports = __webpack_public_path__ + "static/media/state-back-11.261b4501.jpg";